import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { approveBatchEnrollmentInvitation, resetApproveBatchEnrollmentInvitation } from "./approve-batch-enrollment-invitation";

const initialState: ProcessingState = { processing: "idle" };

export const approveBatchEnrollmentInvitationReducer = createReducer<ProcessingState>(initialState, builder => {
  builder
    .addCase(approveBatchEnrollmentInvitation.pending, state => ({ ...state, processing: "pending" }))
    .addCase(approveBatchEnrollmentInvitation.fulfilled, state => ({ ...state, processing: "success" }))
    .addCase(approveBatchEnrollmentInvitation.rejected, state => ({ ...state, processing: "failed" }))
    .addCase(resetApproveBatchEnrollmentInvitation, () => initialState);
});
